import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslationService } from '../../services/translation.service';
import { SystemNotification, SystemNotificationPaged } from '../../classes/notification';
import { Language } from '@tg4/ng-util/*';
import { NotificationService } from '../../services/notification.service';

type SystemNotificationView = SystemNotification & { isDetailOpen: boolean };
@Component({
    selector: 'app-notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss'],
})
export class NotificationModalComponent implements OnInit {
    @Input() public set notifications(page: SystemNotificationPaged) {
        this.notificationLastPage = page.lastPage;
        this.notificationsView = this.notificationListToNotificationViewList(page.notifications);
    };

    public notificationsView: SystemNotificationView[] = [];
    public currentNotificationPage: number = 1;
    public notificationLastPage: number = 1;
    public notificationPageSize: number = 10;
    public selectedLanguage: string = Language.Portuguese.name;
    public readMessagesIds: number[] = [];
    public isLoadingMessages: boolean = false;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _notificationService: NotificationService
    ) {
    }

    ngOnInit() {
        this.selectedLanguage = this._translationService.getSelectedLanguage();
    }

    public toggleNotificationDetail(notification: SystemNotificationView) {
        notification.isDetailOpen = !notification.isDetailOpen;
        if (!notification.isRead) {
            this.markAsRead(notification);
        }

    }
    private notificationListToNotificationViewList(notifications: SystemNotification[]): SystemNotificationView[] {
        return notifications.map((notification: SystemNotification) => {
            return {
                ...notification,
                isDetailOpen: false
            };
        }
        );
    }

    private markAsRead(notification: SystemNotificationView) {
        notification.isRead = true;
        this._notificationService.markAsRead(notification.id).subscribe((response) => {
            this.readMessagesIds.push(notification.id);

        });
    }

    public loadMoreNotifications() {
        this.currentNotificationPage++;
        this.getNotifications();
    }

    public getNotifications() {
        if (this.isLoadingMessages) return;
        this.isLoadingMessages = true;

        this._notificationService.getNotifications(this.currentNotificationPage)
            .subscribe((response) => {
                const page = response.data;
                this.notificationsView = this.notificationsView.concat(this.notificationListToNotificationViewList(page.notifications));
                this.isLoadingMessages = false;
            });
    }

    public async dismiss() {
        await this._modalController.dismiss({
            updatedMessage: (this.readMessagesIds.length > 0)
        });
    }

}
